import { axios } from '@/plugins/axios';
import { TermItem } from '@/models/quote-template';

export class QuoteTermItemService {
  private endpoint: string;

  constructor() {
    this.endpoint = 'v1/quotes/templates/terms/';
  }

  async createQuoteTerm(term: TermItem) {
    return axios
      .post<TermItem>(`${this.endpoint}`, term)
      .then(({ data }) => data);
  }

  async fetchQuoteTerms(language = 'en') {
    return axios
      .get<TermItem[]>(`${this.endpoint}`, {
        headers: {
          'Accept-Language': language
        }
      })
      .then(({ data }) => data);
  }

  async fetchQuoteTerm(id: number) {
    return axios
      .get<TermItem>(`${this.endpoint}${id}/`)
      .then(({ data }) => data);
  }

  async updateQuoteTerm(term: TermItem) {
    return axios
      .patch<TermItem>(`${this.endpoint}${term.id}/`, term)
      .then(({ data }) => data);
  }

  async deleteQuoteTerm(id: number) {
    return axios.delete(`${this.endpoint}${id}/`);
  }
}
